const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL = "/assets/lane4-logo.png";

export const MEDAL_IMAGES = [
  { src: "/assets/medals/bin-02.jpg", alt: "Birmingham Indoor Nationals" },
  { src: "/assets/medals/dmv-sprintfest2.jpg", alt: "DMV Sprintfest" },
  { src: "/assets/medals/mpower01.jpg", alt: "MPowered Athletix" },
  { src: "/assets/medals/nfx-01.jpg", alt: "North Florida Xpress" },
  { src: "/assets/medals/titan-02.jpg", alt: "Titan Track Classic" },
];
